// Ensure the global translations object exists
if (!window.translations) {
	window.translations = {};
}

// Attach the global Translate function
// Makes the 'translate' method below accessible from typescript AND javascript
window.translate = function (key: string, value: string): string {
	if (window.translations != null && Object.prototype.hasOwnProperty.call(window.translations, key)) {
		return window.translations[key];
	}
	// Return the fallback value if no translation is found
	return value;
};

